<template>
  <div id="app">
    <Navbar :brand="brand" @toggleModal="toggleModal()"/>

    <router-view @sendMessage="sendMessage($event)" />

    <button type="button" class="btn fab fab-fixed shadow" @click="toggleModal()">
      <font-awesome-icon icon="comments" size="2x"/>
    </button>

    <b-modal 
      size="xl" 
      title="Contact" 
      header-close-variant="light"
      hide-footer 
      v-model="contactModal.show"
      body-class="p-0"
    >
      <Contact :msg="message" @closeModal="contactModal.show = false" />
    </b-modal>

    <cookie-law 
      theme="blood-orange"
      buttonText="J'accepte"
    >
      <div slot="message">
        Ce site utilise les cookies pour permettre une meilleure expérience de navigation.
        Pour en savoir plus sur nos politiques en matière de gestion des cookies, 
        <router-link to="legal-notes">consultez le lien suivant.</router-link>
      </div>
    </cookie-law>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue'
import Contact from '@/components/Contact.vue'
import NavbarLogo from '@/assets/logos/k-logo-white.svg'
import CookieLaw from 'vue-cookie-law'

export default {
  components: {
    Navbar,
    Contact,
    CookieLaw
  },
  data() {
    return {
      contactModal: {
        show: false
      },
      brand: {
        org: 'SKAN',
        logo: NavbarLogo
      },
      message: {}
    }
  },
  methods: {
    toggleModal() {
      this.contactModal.show = !this.contactModal.show
      return false
    },
    sendMessage(subject) {
      this.message.subject = subject
      this.toggleModal()
      return false
    }
  }
}
</script>

<style>
/*************PANTONE 306C***************
#00B5E2
#bbf1ff
#007490
#001216
****************************************/

html,
body,
#app {
  height: 100%;
  min-height: 100vh;
  color: #001216;
  background-color: #fff;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 14px;
  line-height: 1.42857143;
  -webkit-font-smoothing: auto;
  -moz-osx-font-smoothing: grayscale;
}

.ambiance {
  text-align: center;
}

.card,
.btn,
.modal-content,
.modal-header,
.modal-footer {
  border-radius: 0 !important;
  border: none !important;
}


.form-control,
.form-group > div > .custom-select {
  border-radius: 0 !important;
  background-color: white !important;
}

.input-group-text {
  border-radius: 0 !important;
}

.overlay {
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  background-color: rgba(0,0,0,0.8);
}

.content {
  position: relative;
  z-index: 10;
}


/* ADAPTIVITÉ */
/* ADAPTIVITÉ */
/* ADAPTIVITÉ */
/* ADAPTIVITÉ */

/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 768px) {
  html,
  body,
  #app { font-size: 10px; }

  .fab-sm {
    height: 40px !important;
    width: 40px !important;
  }

  .text-right-lg { 
    text-align: center; 
  }
} 

/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {} 

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
}

/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
  .text-right-lg { 
    text-align: right; 
  }
}

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {}


/* COULEURS */
/* COULEURS */
/* COULEURS */
/* COULEURS */

.white {
  background-color: #fff !important;
}

  .text-white {
    color: #fff !important;
  }

  .text-white.hoverable:hover {
    color: #bbf1ff !important;
  }

.blue {
  background-color: #00B5E2 !important;
}

.text-blue {
  color: #00B5E2 !important;
}

  .blue.outlined {
    background-color: transparent !important;
    border: 2px solid #00b5e2 !important;
    text-transform: uppercase !important;
    font-weight: bold;
  }

  .button.blue.outlined {
    transition: background-color 0.5s ease, border 0.5s ease, font-size 0.5s ease;
  }

.black {
  background-color: #000 !important;
}

  .black.outlined {
    background-color: transparent !important;
    border: 2px solid #000 !important;
    text-transform: uppercase !important;
  }

.text-black {
  color: #000 !important;
}

.dark-color {
  background-color: #001216 !important;
}

  .text-dark-color {
    color: #001216 !important;
  }

  .dark-color.outlined {
    background-color: transparent !important;
    border: 2px solid #000 !important;
    text-transform: uppercase !important;
  }

.text-silver {
  color: silver !important;
}

.text-red {
  color: red !important;
}

a {
  color: #00B5E2
}

.modal-body {
  background-color: transparent;
  border: none;
}

.modal-header {
  background-color: #00B5E2;
  color: #fff;
}

.shaded {
  background-color: rgba(0,0,0,0.5);
}

.shadow {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19) !important;
}

/* TEXTE */
/* TEXTE */
/* TEXTE */
/* TEXTE */

.upper {
  text-transform: uppercase !important;
}

.bold {
  font-weight: bold !important;
}

.slogan {
  text-transform: uppercase;
  font-weight: bold;
}

.text-smaller {
  font-size: 80%;
}

.text-bigger {
  font-size: 120%;
}

.text-150 {
  font-size: 150% !important;
}

.text-2x {
  font-size: 200% !important;
}

.list-unstyled {
  list-style-type: none !important;
}

.searchResults {
  list-style-type: none !important;
  background-color: rgba(255,255,255,0.5);
  padding: 0;
}

.searchResults > li {
  padding: 10px;
}


/* BOUTONS */
/* BOUTONS */
/* BOUTONS */
/* BOUTONS */

.fab {
  z-index: 10;
  width: 65px;
  height: 65px;
  border-radius: 50% !important;
  background-color: #00B5E2 !important;
  color: #fff !important;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  transition: all 0.2s ease !important;
}

.fab:hover {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.fab-sm {
  width: 55px;
  height: 55px;
}

.fab-fixed {
  position: fixed;
  bottom: 2vh;
  right: 2vw;
}

.btn-cta {
  right: -100%;
  border-radius: 25px !important;
  font-weight: bold !important;
  background-color: rgba(0,181,226, 0.3) !important;
  color: #fff !important;
  -webkit-transition: all ease-in-out;
  transition: all ease-in-out;
  transition-duration: 0.2s;
}

.ebook-cta {
  right: -100%;
  border-radius: 25px !important;
  font-weight: bold !important;
  background-color: #001216 !important;
  color: #fff !important;
  -webkit-transition: all ease-in-out;
  transition: all ease-in-out;
  transition-duration: 0.2s;
}

.btn-cta:hover {
  background-color: #00b5e2 !important;
  font-weight: bold;
  color: #fff !important;
  transform: scale(1.05) !important;
}

.ebook-cta:hover {
  background-color: rgba(0,181,226, 1) !important;
  font-weight: bold;
  color: #fff !important;
  /* transform: scale(1.05) !important; */
}

.form-control,
.input-group-append > .btn,
.btn-group-toggle > .btn,
form > .btn {
  background-color: rgba(0,181,226, 0.5);
  color: #fff;
}

.btn-group-toggle > .btn.active {
  background-color: #00b5e2 !important;
}

.btn-group-toggle > .btn:hover {
  background-color: #00b5e2;
}


/* ANIMATIONS */
/* ANIMATIONS */
/* ANIMATIONS */
/* ANIMATIONS */

.slide-fade-enter, .slide-fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}

.slide-fade-enter-active {
  transition: all .3s ease 1s;
}

.slide-fade-leave-active {
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

@keyframes slide-from-right {
  100% { right: 0; }
}

@-webkit-keyframes slide-from-right {
  100% { right: 0; }
}

.blinking-cursor {
  color: transparent;
  padding: 0 2px;
  -webkit-animation: 1s blink step-end infinite;
  animation: 1s blink step-end infinite;
}

@keyframes blink {
  from, to {
    background-color: transparent;
  }
  50% {
    background-color: #fff;
  }
}

@-webkit-keyframes blink {
  from, to {
    background-color: transparent;
  }
  50% {
    background-color: #fff;
  }
}

.slide-enter,
.slide-leave-to {
  transform: scaleY(0.7);
  opacity: 0;
}
 
.slide-enter-to,
.slide-leave {
  opacity: 1;
  transform: scaleY(1);
}
 
.slide-enter-active,
.slide-leave-active {
  transition: all 0.3s ease-out;
  transform-origin: top center;
}


/* IMAGES */
/* IMAGES */
/* IMAGES */
/* IMAGES */

img.logo {
    width: 50%;
    min-width: 200px;
    max-width: 600px;
}

.img-white {
  filter: grayscale(10) brightness(8);
}

.header-ambiance {
  max-height: 50vh;
}

.ambiance > img {
  width: 100%;
  min-width: 225px;
  max-width: 30vw;
  max-height: 50vh;
}



/* AUTRES */
/* AUTRES */
/* AUTRES */
/* AUTRES */

.identify {
  border: 1px solid lime;
}

.reveal {
  border: 2px solid lime;
}

</style>
